import axios from 'axios';
import { generateUrl } from '../utils/get-page-url';

export default class Reviews {
  constructor() {
    this.apiKey = process.env.REVIEWS_API_KEY;
    this.baseUrl = process.env.REVIEWS_BASE_URL;
    this.storeId = process.env.STORE_ID;
  }

  getProductReviewData = (productIds, callback, perPage = 5, page = 1, minRating = 4) => {
    const params = {
      store: this.storeId,
      sku: productIds.filter((id) => !!id).join(';'),
      per_page: perPage,
      page,
      minRating
    };

    const url = generateUrl(`${this.baseUrl}/reviews`, params);

    axios.get(url).then(callback);
  };

  getBatchProductReviewData = (productIds, callback) => {
    const params = {
      store: this.storeId,
      sku: productIds.filter((id) => !!id).join(';'),
      minRating: 4
    };

    const url = generateUrl(`${this.baseUrl}/product/rating-batch`, params);

    axios.get(url).then(callback);
  };

  postReview = (data, onSuccess, onFail) => {
    const url = `${this.baseUrl}/product/review/new`;

    axios.post(url, { store: this.storeId, apiKey: this.apiKey, ...data })
      .then((response) => {
        const { data: res } = response;

        if (!res.success) {
          onFail();
        } else {
          onSuccess();
        }
      })
      .catch(onFail);
  };
}
